import { Injectable } from '@angular/core';
import { DataStorageService } from './data-storage.service';
import { Token } from '@angular/compiler';
import { StorageService } from '@clavisco/core';
import { IToken } from '../interfaces/i-token';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(
    private dataStorageService: DataStorageService,
    private storageService: StorageService
  ) { }

  /**
    * <summary>
    * Checks if the user is authenticated by validating the current session token.
    * </summary>
    *
    * @returns `true` if the user is authenticated (valid and non-expired token), otherwise `false`.
    *
    * @example
    * // Check if the user is authenticated
    * const isAuthenticated = IsAuthenticated();
    */
  public IsAuthenticated(): boolean {
    try {
      const currentSession = this.dataStorageService.GetItem<IToken>('currentUser');
      if (currentSession === null) return false;

      const TOKEN = currentSession;

      if (TOKEN) {
        const expires: Date = new Date(TOKEN.expires);
        const today: Date = new Date();
        const currentUTCDate: Date = new Date(today.getTime() + today.getTimezoneOffset() * 60000); // convertir a UTC

        if (currentUTCDate < expires) { // posee token y el mismo aun no expira, es valido
          return true;
        }
      }
    } catch (error) {
      console.error('Error decoding session:', error);
      return false;
    }
    return false;
  }

  /**
     * <summary>
     * Converts a date string in `DD/MM/YYYY HH:mm:ss` format to ISO string format `YYYY-MM-DDTHH:mm:ss`.
     * </summary>
     * 
     * @param dateString The date string to be converted.
     * @returns The converted date in ISO string format.
     *
     * @example
     * // Convert a date string
     * const isoDate = convertDate('25/12/2025 15:30:00');
     */
  convertDate(dateString: string): string {
    const [datePart, timePart] = dateString.split(' ');
    const [day, month, year] = datePart.split('/');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${timePart}`;
  }

  /**
   * <summary>
   * Logs out the current user by cleaning up the storage and removing session data.
   * </summary>
 */
  public Logout(): void {
    this.storageService.CleanStorage();
    this.dataStorageService.RemoveItem<IToken>('currentUser');
  }


}
